import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=3c233400&scoped=true&"
import script from "./ContactDetails.vue?vue&type=script&lang=js&"
export * from "./ContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=3c233400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c233400",
  null
  
)

export default component.exports